// extracted by mini-css-extract-plugin
export default {"cbuForm":"FormularioCBUCVU_cbuForm__wi2p7"};